import Menu from "ant-design-vue/es/menu";
// import Icon from 'ant-design-vue/es/icon'

const { Item, SubMenu } = Menu;

export default {
  name: "IMenu",
  props: {
    menuData: {
      type: Array,
      required: true,
    },
    theme: {
      type: String,
      required: false,
      default: "dark",
    },
    mode: {
      type: String,
      required: false,
      default: "inline",
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      openKeys: [],
      selectedKeys: [],
      cachedOpenKeys: [],
    };
  },
  computed: {
    rootSubmenuKeys: (vm) => {
      let keys = [];
      vm.menuData.forEach((item) => {
        keys.push(item.path);
      });
      return keys;
    },
  },
  created() {
    this.updateMenu();
  },
  watch: {
    collapsed(val) {
      if (val) {
        this.cachedOpenKeys = this.openKeys;
        this.openKeys = [];
      } else {
        this.openKeys = this.cachedOpenKeys;
      }
    },
    $route: function () {
      this.updateMenu();
    },
  },
  methods: {
    renderIcon: function (h, icon) {
      return null;
      // if (icon === undefined || icon === '') icon = 'none'
      // return icon === 'none' ? null
      //   : h(
      //     Icon,
      //     {
      //       props: {type: icon}
      //     })
    },
    isValidUrl(url) {
      try {
        new URL(url);
        return true;
      } catch (error) {
        return false;
      }
    },
    renderMenuItem: function (h, menu, pIndex, index) {
      return h(
        Item,
        {
          key: menu.path ? menu.path : "item_" + pIndex + "_" + index,
        },
        [
          h(
            "a",
            {
              attrs: {
                href: this.isValidUrl(menu.path)
                  ? menu.path
                  : "#" + (menu.newPath ? menu.newPath : menu.path),
                target: this.isValidUrl(menu.path) ? "_blank" : "",
              },
            },
            [this.renderIcon(h, menu.icon), h("span", [menu.name])]
          ),
        ]
      );
    },
    renderSubMenu: function (h, menu, pIndex, index) {
      const this2_ = this;
      let subItem = [
        h("span", { slot: "title" }, [
          this.renderIcon(h, menu.icon),
          h("span", [menu.name]),
        ]),
      ];
      let itemArr = [];
      let pIndex_ = pIndex + "_" + index;
      menu.children.forEach(function (item, i) {
        itemArr.push(this2_.renderItem(h, item, pIndex_, i));
      });
      return h(
        SubMenu,
        { key: menu.path ? menu.path : "submenu_" + pIndex + "_" + index },
        subItem.concat(itemArr)
      );
    },
    renderItem: function (h, menu, pIndex, index) {
      if (!menu.hidden) {
        return menu.children
          ? this.renderSubMenu(h, menu, pIndex, index)
          : this.renderMenuItem(h, menu, pIndex, index);
      }
    },
    renderMenu: function (h, menuTree) {
      const this2_ = this;
      let menuArr = [];
      menuTree.forEach(function (menu, i) {
        if (!menu.hidden) {
          menuArr.push(this2_.renderItem(h, menu, "0", i));
        }
      });
      return menuArr;
    },
    onOpenChange(openKeys) {
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (this.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
    updateMenu() {
      let routes = this.$route.matched.concat();
      let temp = [];
      routes.forEach((item) => temp.push(item.path));
      this.selectedKeys = temp;
      // if (routes.length >= 4 && this.$route.meta.hidden) {
      //   routes.pop()
      //   this.selectedKeys = [routes[0].path,routes[1].path,routes[].path]
      // } else {
      //   this.selectedKeys = [routes.pop().path]
      // }

      let openKeys = [];
      if (this.mode === "inline") {
        routes.forEach((item) => {
          openKeys.push(item.path);
        });
      }

      this.collapsed
        ? (this.cachedOpenKeys = openKeys)
        : (this.openKeys = openKeys);
    },
  },
  render(h) {
    return h(
      Menu,
      {
        props: {
          theme: this.$props.theme,
          mode: this.$props.mode,
          openKeys: this.openKeys,
          selectedKeys: this.selectedKeys,
        },
        on: {
          openChange: this.onOpenChange,
          select: (obj) => {
            this.selectedKeys = obj.selectedKeys;
            this.$emit("select", obj);
          },
        },
      },
      this.renderMenu(h, this.menuData)
    );
  },
};



// WEBPACK FOOTER //
// ./src/components/menu/menu.js